import AccountAPICall from "src/service/AdminAPICalls/AccountAPICall";

class AccountRepository {

    getAccountList = async (params) => {
        return await new AccountAPICall().getAccountList(params);
    };

    getAccountExport = async (params) => {
        return await new AccountAPICall().exportAccountList(params);
    }

    getAccountDetail = async (params) => {
        return await new AccountAPICall().getAccountDetail(params);
    };

    getAccountUserList = async (params) => {
        return await new AccountAPICall().getAccountUserList(params);
    };

    exportAccountUsrList = async (params) => {
        return await new AccountAPICall().exportAccountUsrList(params);
    }

    updateUnsponsorAcctByUser = async (params) => {
        return await new AccountAPICall().updateUnsponsorAcctByUser(params);
    }

    emailAccounts = async (params) => {
        return await new AccountAPICall().emailAccouts(params);
    }

    emailAccountUserList = async (params) => {
        return await new AccountAPICall().emailAccountUserList(params);
    }

}

export default AccountRepository;